import React from "react";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <Helmet async>
        {`
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6476193408116473"
      crossorigin="anonymous"></script>
      `}
      </Helmet>
      <noscript>
        <iframe
          title="gtag"
          src="https://www.googletagmanager.com/ns.html?id=GTM-PV8DX9S"
          height="0"
          width="0"
          style={`display:none;visibility:hidden;`}
        ></iframe>
      </noscript>

      <header className="container">
        <hgroup>
          <h1>
            <NavLink to="/">Instant QR Codes</NavLink>
          </h1>
          <h2>Generate QR Codes, Free &amp; Instant.</h2>
        </hgroup>
      </header>
    </>
  );
}

export default Header;
